import React, { useCallback, useState } from 'react';
import Code from '../../Code/Code';
import ComboBox from '../../../../components/ComboBox/ComboBox';
import EmbedCodeCopyButton from '../../EmbedCodeCopyButton/EmbedCodeCopyButton';
import { UnControlled as ReactCodeMirror } from 'react-codemirror2';
import getHostUrlForIntegrations from '../../../../../services/mini/getHostUrlForIntegrations';

const htmlCodeMirrorOptions = {
    lineNumbers: false,
    readOnly: true,
    mode: {
        name: 'javascript',
    },
    scrollbarStyle: null,
    cursorScrollMargin: -1000,
};
const googleFontCode = '<link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap" rel="stylesheet">';

const alanReactInstallCode = 'npm install @alan-ai/alan-sdk-web --save';

const alanReactImportCode = 'import alanBtn from \'@alan-ai/alan-sdk-web\';';

function alanReactClassComponentCode(alanKey) {
    return `componentDidMount() {
  this.alanBtnInstance = alanBtn({ 
    key: '${alanKey}',
    host: '${getHostUrlForIntegrations()}',
    onCommand: (commandData) => {
      if (commandData.command === 'go:back') {
        //call client code that will react to the received command
      }
    },
  });
}`;
}

function alanReactFunctionalComponentCode(alanKey) {
    return `useEffect(() => {
  alanBtn({
      key: '${alanKey}',
      host: '${getHostUrlForIntegrations()}',
      onCommand: (commandData) => {
        if (commandData.command === 'go:back') {
          // Call the client code that will react to the received command
        }
      }
  });
}, []);`;
}

const codeModes = [
    { name: 'Functional Component', key: 'func' },
    { name: 'Class Component', key: 'klass' },
];

export function ReactTab({ alanKey }) {
    const [codeMode, setCodeMode] = useState('func');

    const changeCodeModeCb = useCallback((codeModeObj) => {
        setCodeMode(codeModeObj.key);
    }, []);

    return <div className="embed-code-tab">
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description">
            </div>
            <div className="embed-code-tab_dash"></div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_not-highlighted-code">
                    <br />
                </div>
            </div>
        </div>
        <ComboBox
            values={codeModes}
            valueKey="key"
            valueName="name"
            classes="code-mode-combo-box light-blue-with-border"
            selectedValueId={codeMode}
            onValueSelect={changeCodeModeCb}
            renderItem={(codeModeItem) => {
                return <div style={{ paddingLeft: '8px' }}
                    key={codeModeItem.key}>
                    {codeModeItem.name}
                </div>;
            }} />
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Install the Alan SDK Web package
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="bash" type="code">
                        {alanReactInstallCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanReactInstallCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Import the Alan button
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <ReactCodeMirror
                        value={alanReactImportCode}
                        options={htmlCodeMirrorOptions} />
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={alanReactImportCode} />
                    </div>
                </div>
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc5">
                Add the Alan button to your component. Handle commands from the Alan AI Studio
            </div>
            <div className="embed-code-tab_dash embed-code-desc5">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                {codeMode === 'klass' ?
                    <div className="embed-code-tab_highlighted-code">
                        <ReactCodeMirror
                            value={alanReactClassComponentCode(alanKey)}
                            options={htmlCodeMirrorOptions} />
                        <div className="embed-code-tab_copy">
                            <EmbedCodeCopyButton code={alanReactClassComponentCode(alanKey)} />
                        </div>
                    </div> :
                    <div className="embed-code-tab_highlighted-code">
                        <ReactCodeMirror
                            value={alanReactFunctionalComponentCode(alanKey)}
                            options={htmlCodeMirrorOptions} />
                        <div className="embed-code-tab_copy">
                            <EmbedCodeCopyButton code={alanReactFunctionalComponentCode(alanKey)} />
                        </div>
                    </div>
                }
            </div>
        </div>
        <div className="embed-code-tab_line">
            <div className="embed-code-tab_description embed-code-desc2">
                Add a link to the font
            </div>
            <div className="embed-code-tab_dash embed-code-desc2">
                <div className="embed-code-tab_separator" />
            </div>
            <div className="embed-code-tab_code">
                <div className="embed-code-tab_highlighted-code">
                    <Code highlighted={true} category="web" type="tag">
                        {googleFontCode}
                    </Code>
                    <div className="embed-code-tab_copy">
                        <EmbedCodeCopyButton code={googleFontCode} />
                    </div>
                </div>
            </div>
        </div>
    </div>;
}
